import makeCrud from '@/store/site/localization/crud'

// Stok durumu (depo bakiyeleri) — listeleme salt-okunur; eşik/düzeltme aksiyonları sayfa içinde.
export default makeCrud('ecommerce_stock_status')
